import type { Getter, Setter } from 'jotai';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import type { AddNodePayload } from '../../../types/skeleton-template-builder.type';
import { selectedNodeIdAtom, templateNodesAtom } from '../template-atoms';
export const addNodeCommandFactory = (get: Getter, set: Setter): UndoRedoActionCommand<AddNodePayload, void> => {
  let previousSelectedId: string | null = null;
  return {
    execute: payload => {
      const {
        node
      } = payload;
      previousSelectedId = get(selectedNodeIdAtom);
      set(templateNodesAtom, [...get(templateNodesAtom), node]);
      set(selectedNodeIdAtom, node.id);
    },
    undo: payload => {
      const {
        node
      } = payload;
      set(templateNodesAtom, get(templateNodesAtom).filter(n => n.id !== node.id));
      set(selectedNodeIdAtom, previousSelectedId);
    }
  };
};